import { render, staticRenderFns } from "./ProjectLeaveSlackNotificationSettings.vue?vue&type=template&id=73dee9bc&scoped=true&"
import script from "./ProjectLeaveSlackNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectLeaveSlackNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLeaveSlackNotificationSettings.vue?vue&type=style&index=0&id=73dee9bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dee9bc",
  null
  
)

export default component.exports